import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import ContentMasteryTestSpeechRateGauge from './ContentMasteryTestSpeechRateGauge';
import { ContentMasterySpeechRateListService } from '../../services/ContentListService';
import ContentHistoryService from '../../services/ContentHistoryService';

class ContentMasteryTestSpeechRateGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    ContentMasterySpeechRateListService.load();
  }

  render() {
    const data = ContentMasterySpeechRateListService.getChart();
    return (
      <ContentMasteryTestSpeechRateGauge
        loading={
          ContentMasterySpeechRateListService.fetchCurrent.fetching ||
          ContentMasterySpeechRateListService.fetchPrevious.fetching
        }
        currentValue={toJS(data.current)}
        previousValue={toJS(data.previous)}
        formatter={ContentMasterySpeechRateListService.getFormattedValue}
        onClickHistory={() => ContentHistoryService.openDialog('MASTERY_TEST_ITEM_EXECUTION_SPEECH_RATE')}
      />
    );
  }
}

export default observer(ContentMasteryTestSpeechRateGaugeContainer);
